export { default as DocumentTab } from './organisms/DocumentLibrary';
export { default as UploadFiles } from './molecules/File/Upload';